import React from 'react';

import MapLayersLegendsView from './MapLayersLegends.view';
import { ConnectorPowerLabel, ConnectorStatus } from 'utils/enums/chargingType';

type Props = {
  selectedPowerType?: ConnectorPowerLabel[];
  onSelectPowerType?: (powerType: ConnectorPowerLabel) => void;
  connectorStatus?: ConnectorStatus;
  onConnectorStatusChange?: (status: ConnectorStatus) => void;
};

const MapLayersLegends: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MapLayersLegendsView
      selectedPowerType={props.selectedPowerType}
      onSelectPowerType={props.onSelectPowerType}
      connectorStatus={props.connectorStatus}
      onConnectorStatusChange={props.onConnectorStatusChange}
    ></MapLayersLegendsView>
  );
};

MapLayersLegends.displayName = 'MapLayersLegends';
MapLayersLegends.defaultProps = {};

export default MapLayersLegends;
